export default {"src":"/_next/static/media/unions.e8d8ea97.svg","height":22,"width":24,"blurWidth":0,"blurHeight":0};